/* eslint-disable camelcase */
import { composerSettings } from '@ddc-webplatform/cmsc-modules';

// Put locale data into context for react intl formatting

import en_US from './en-US';
import en_CA from './en-CA';
import es_MX from './es-MX';
import es_US from './es-US';
import fr_CA from './fr-CA';

// this way we can easily look up the data we need by key instead of a bunch of switch statements
const allMessages = {
	en_US,
	en_CA,
	es_MX,
	es_US,
	fr_CA
};

/* get the locale name and corresponding messages based on url locale param value */

export const localeData = (() => {
	const locale =
		composerSettings.getComposerSetting('applicationLocale') || 'en_US';

	const localeName = locale.replace(/_/, '-');
	const localeMessages = allMessages[locale];

	return { localeName, localeMessages };
})();

// Intl polyfill is no longer required — all target browsers support it natively.
export const polyfillLocalization = Promise.resolve(allMessages);
